

// 各種カルーセルの設定
var globalProducts = new Swiper ('.swiper-global-products', {
  // init: false,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  grabCursor: true,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // when window width is >= 320px
    820: {
      slidesPerView: 3,
    }
  }
});

var globalBedrooms = new Swiper('.swiper-global-bedrooms', {
    // init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1200,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.bedrooms-pagination',
      clickable: true
    },
    autoplay: {
      delay: 5000
    },
    on: {
      init: changeSlideName
    }
});
// var globalBedroomsChange = changeSlideName( globalBedrooms );

var globalBarRestaurants = new Swiper ('.swiper-global-bar-restaurants', {
    // init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1200,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.restaurants-pagination',
      clickable: true
    },
    autoplay: {
      delay: 5000
    },
    on: {
      init: changeSlideName
    }
});
// var globalBarRestaurantsChange = changeSlideName( globalBarRestaurants );


var discoveryPickup = new Swiper ('.swiper-discovery-pickup', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 900,
    // grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    autoplay: {
      delay: 5000
    }
});


//画面幅からデバイスを推測
function deviceType(){

	windowWidth  = window.innerWidth;

	if(windowWidth <= 820){

		return 'sp';

	} else if(windowWidth > 821 && windowWidth <= 1279) {

		return 'tab';

	} else if(windowWidth > 1280) {

		return 'pc';

	}

}

// Swiper カスタム
function changeSlideName( target ){

  var target = this;

  if( ! target  ) return false;

  var currentInfo,
      targetTitleLink,
      changeTimer,
      slideIndex,
      currentIndex;

  // 初期処理
  var currentSlide  = target.slides[1];
  var slideDataName = currentSlide.getAttribute('data-name');
  var slideDataHref = currentSlide.getAttribute('data-href');
  var slideWrapper  = target.$el[0];
  var slideTitles   = slideWrapper.nextElementSibling;

  var jq_slideTitles  = $(slideTitles);
  targetTitleLink     = jq_slideTitles.find('.link');
  currentInfo = [ slideDataName, slideDataHref ];

  targetTitleLink.find('a').attr('href', currentInfo[1] );
  targetTitleLink.find('a span').text( currentInfo[0] );

  // スライド時の処理
  target.on('slideChangeTransitionStart', function(){

    clearTimeout( changeTimer );

    slideIndex    = target.realIndex;
    currentIndex  = slideIndex + 1;

    currentSlide  = target.slides[currentIndex];
    slideDataName = currentSlide.getAttribute('data-name');
    slideDataHref = currentSlide.getAttribute('data-href');
    slideWrapper  = target.$el[0];
    slideTitles   = slideWrapper.nextElementSibling;

    jq_slideTitles  = $(slideTitles);
    targetTitleLink = jq_slideTitles.find('.link');

    targetTitleLink.addClass('hide');

    currentInfo = [ slideDataName, slideDataHref ];

    changeTimer = setTimeout( function(){

      targetTitleLink.find('a').attr('href', currentInfo[1] );
      targetTitleLink.find('a span').text( currentInfo[0] );
      targetTitleLink.removeClass('hide');

    }, 450 );

  });

}

// ハンバーガーメニュー
function drawerControl() {

  var objectBody = $('body');
  var menuButton = $('#menuButton');
  var drawerMenu = $('#drawerGlobalMenu');
  var localNav   = $('#drawerLocalMenu');
  var localNavTimer;

  if( menuButton.length === 0 ) return false;

  menuButton.on({

    'click' : function(){

      clearTimeout( localNavTimer );

      if( objectBody.hasClass('drawer-open') ){

        objectBody
          .removeClass('drawer-open')
          .addClass('drawer-close');

        drawerMenu.removeClass('show');
        localNav.hide();

      } else if( objectBody.hasClass('drawer-close') ) {

        objectBody
          .removeClass('drawer-close')
          .addClass('drawer-open');

        drawerMenu.addClass('show');
        localNavTimer = setTimeout( function(){

          localNav.show();

        }, 300 );

      } else {

        objectBody
          .addClass('drawer-open');
          drawerMenu.addClass('show');

        localNavTimer = setTimeout( function(){

          localNav.show();

        }, 300 );

      }

      return false;
    }

  });

  drawerMenu.on({
    'mouseleave' : function(){
    }

  });

}


// ハンバーガーのサブメニュー表示
function localNavigationControl( object ){

  var global_nav      = $('#drawerGlobalMenu .global');
  var local_nav       = $('#drawerLocalMenu');
  var local_close_btn = local_nav.find('button.close');
  var device_type     = deviceType();

  var global_nav_main = global_nav.find('.global__main');

  global_nav_main.find('li').each(function(){

    $(this).find('a').on({
      'mouseenter' : function(){

        local_nav.removeClass('show');

        var label = $(this).attr('data-label');
        var local_nav_object = local_nav.find( '.' + label );

        if( local_nav_object.length === 0 ) return false;

        if( device_type === 'sp' ){

          $(this).on({
            'click' : function(){
              return false;
            }
          });

        }

        local_nav.addClass('show');

      }

    });

  });

  local_nav.on({
    'mouseleave' : function(){

      local_nav.removeClass('show');

    }
  });

  local_close_btn.on({
    'click' : function(){

      local_nav.removeClass('show');

    }
  });

}


// ドロップダウンリスト
function dropdownControl( object ) {

  if (object.length === 0) return false;

  var cms_dropdown = $('.branch__nav .sub-navigation');
  // console.debug(cms_dropdown.length);


  var object_button = object.find('> a');
  var object_list   = object.find('ul');

  object_list.css({
    minWidth: object.width()
  });

  object_button.on({
    'click' : function(){
      return false;
    },
  });

  var closeTimer  = null;
  var device_type = deviceType();

  if( device_type != 'sp' ){

    object.on({
      'mouseenter' : function(){

        clearTimeout( closeTimer );
        closeTimer = null;

        var target        = $(this).children().next();
        var target_height = 0;

        target.find('li').each( function(){
          target_height = $(this).outerHeight() + target_height;
          height_reset  = 0;
        });

        object_button
          .addClass('open');

        target
          .addClass('show')
          .css({
            height: target_height
          });
      },
      'mouseleave' : function(){
        var target        = $(this).children().next();
        closeTimer = setTimeout( function(){
        object_button
          .removeClass('open');
        target
          .removeClass('show')
          .css({
            height: height_reset
          });
        }, 300 );
      }
    });

  } else {

    // console.debug(object_button);

    // object_button.forEach(function (element, index) {
    //   element.addEventListener('touchstart', function (e) {
    //     console.debug(e);
    //   });

    // });


    object_button.on('click', function (e) {
      

      clearTimeout( closeTimer );
      closeTimer = null;

      console.debug($('.branch__nav .sub-navigation'));

      if( $(this).hasClass('open') ){

        var target = $(this).next();
        object_button
          .removeClass('open');

        if (cms_dropdown.length > 0) {

          target
            .addClass('sub-menu')
            .removeClass('show');

        } else { 

          target
            .addClass('hiddenlist')
            .removeClass('show');

        }


      } else {

        var target = $(this).next();

        // console.debug( target.hasClass('hiddenlist') );

        object_button
          .addClass('open');
        
        if (cms_dropdown.length > 0) {

          target
            .removeClass('sub-menu')
            .addClass('show');
          
        } else { 

          target
            .removeClass('hiddenlist')
            .addClass('show');

        }
      }

    });

  }

}

// SNSリスト
function listControl( selector ) {
  //var selector = selector;
  var object   = $(selector);
  if( object.length === 0 ) return false;

  var list_tabs     = object.find('.list-tabs');
  var list_contents = object.find('.list-contents');

  var tab_objects      = list_tabs.find('ul li');
  var tab_contents     = list_contents.find('.contents-wrapper');
  var tab_close_button = list_contents.find('button.close');

  var closeTimer = null;
  var contentsTimer = null;

  tab_objects.each( function() {

    $(this).find('a').on({
      'click' : function(){
      },
      'mouseenter' : function(){

        clearTimeout( contentsTimer );
        var content_height;
        var data = $(this).attr('data-tab-content');

        tab_objects.find('a').removeClass('current');
        $(this).addClass('current');
        list_tabs.addClass('active');


        list_contents.find('.contents-wrapper').each(function(){
          $(this).removeClass('show');
        });

        contentsTimer = setTimeout( function(){

          list_contents.find('.contents-wrapper').each(function(){

            if( $(this).is( '#' + data ) ){
              $(this).addClass('show');

              var content_height = $(this).outerHeight();
              list_contents
                .addClass('open')
                .css({
                  height: content_height
                });

            }

          });

        }, 300 );

      }
    });

  });

  // メニューを選択時はタイマーをリセット
  tab_contents.on({

    'mouseenter' : function(){

      clearTimeout( contentsTimer );
      contentsTimer = null;

    }

  });

  // マウスアウトで領域を非表示
  object.on({

    'mouseleave' : function(){

      contentsTimer = setTimeout( function(){

        list_contents
          .removeClass('open')
          .css({
            height: 0
          });
        tab_objects.find('a').removeClass('current');
        list_tabs.removeClass('active');

      }, 600 );

    }
  });

  tab_close_button.on({

    'click' : function(){

      list_contents
        .removeClass('open')
        .css({
          height: 0
        });
      tab_objects.find('a').removeClass('current');
      list_tabs.removeClass('active');

      return false;

    }

  });


}


// ブッキングリスト
function bookingControl( object ) {

  if( object.length === 0 ) return false;

  var object_button = object.find('a.ctrl');
  var object_list   = object.find('ul.hiddenlist');
  var device_type   = deviceType();

  if( device_type != 'sp' ){

    object.on({

      'mouseenter' : function(){

        var target        = $(this).children().next();
        target.removeClass('side-hide');

      },
      'mouseleave' : function(){

        var target        = $(this).children().next();
        target.addClass('side-hide');

      }

    });

  } else {

    var menuButton         = $('#menuButton');
    var bookingCloseButton = $('#bookingCloseButton');
    bookingCloseButton.hide();


    object.find('a.link').on({

      'click' : function(){

        var target        = $(this).next();
        if( !target.hasClass('side-hide') ){

          menuButton.parent().css({
            zIndex : 130
          });
          target.addClass('side-hide');
          bookingCloseButton.hide();

        } else {

          menuButton.parent().css({
            zIndex : 1
          });
          target.removeClass('side-hide');
          setTimeout( function(){

            bookingCloseButton.fadeIn();

          }, 300 );


        }

      }

    });

    bookingCloseButton.on({

      'click' : function(){

        var target = $(this).parent().parent();
        menuButton.parent().css({
          zIndex : 130
        });
        target.addClass('side-hide');
        bookingCloseButton.hide();

      }

    });

  }


}


// 記事のブランチを変更
function changeLocation() {
  var select_location = $('#select-location');
  if( select_location.length === 0 ) return false;

  var selectBox = $('select[name="location"]').selectBoxIt().data("selectBox-selectBoxIt");
  var closeTimer;
  selectBox.setOptions({
    showEffect : 'slideDown',
    showEffectSpeed : 200,
    hideEffect : 'slideUp',
    hideEffectSpeed : 200
  });

  $('.selectboxit-options').on({
    'mouseenter' : function(){
      clearTimeout( closeTimer );
    },
    'mouseleave' : function(){
      closeTimer = setTimeout( function(){

        selectBox.close();

      }, 300 );
    }
  });

  select_location.on({
    'mouseenter' : function(){
      clearTimeout( closeTimer );
      selectBox.open();
    },
    'change' : function(){

      Cookies.remove('location');

      var current_url  = location.href;
      var cleaning_url = current_url.replace(/\?.*$/,"");

      var location_val = $(this).val();
      var href_url;

      if( location_val.length === 0 ){

        href_url = cleaning_url;

      } else {

        Cookies.set('location', location_val, { expires: 1, path: '/' });
        href_url = cleaning_url + '?location=' + location_val;

      }

      // location.href = href_url;
      $('body')
        .removeClass('done')
        .addClass('loading');

      setTimeout( function(){

        location.href = href_url;

      }, 500 );

    }
  });


  var change_genre = $('.change-genre')
  change_genre.find('ul li').each(function(){
    var this_link       = $(this).find('a');
    var this_link_url   = this_link.attr('href');
    var location_cookie = Cookies.get('location');

    if( location_cookie === undefined ) return false;

    var link_location_url = this_link_url + '?location=' + location_cookie;
    this_link.attr('href', link_location_url);

  });

}


// 記事のジャンルを変更
function changeGenre() {

  var select_genre = $('#select-genre');
  if( select_genre.length === 0 ) return false;

  $('select[name="genre"]').selectBoxIt();

  select_genre.on({
    'change' : function(){

      var href_url;
      var genre_url = $(this).val();

      var location_cookie = Cookies.get('location');
      if( location_cookie === undefined ) {

        href_url = genre_url;

      } else {

        href_url = genre_url + '?location=' + location_cookie;

      }

      // location.href = href_url;
      $('body')
        .removeClass('done')
        .addClass('loading');

      setTimeout( function(){

        location.href = href_url;

      }, 500 );

    }
  });

}


// 部屋タイプの固定サイドバー
function fixedRoomSideMenu( winTopPos ){

  var roomTypeNav = document.getElementById('roomTypeNav');
  var roomTypeContent = document.getElementById('roomTypeContent');

  if( roomTypeNav === null ) return false;

  var roomTypeNavPos        = roomTypeNav.offsetTop;
  var roomTypeContentHeight = roomTypeContent.clientHeight;
  var topMargin = 154; //120
  
  if( winTopPos > ( roomTypeNavPos - topMargin ) ){

    roomTypeNav.classList.add('fixed');

    if( winTopPos > roomTypeContentHeight - topMargin ) {

      roomTypeNav.classList.remove('fixed')
      roomTypeNav.classList.add('ended')

    } else {

      roomTypeNav.classList.remove('ended')
      roomTypeNav.classList.add('fixed')

    }

  } else {

    roomTypeNav.classList.remove('fixed');

  }

}

// 地図の固定
function fixedMap(winTopPos, scrollTimer) {

  var mapSpotList = jQuery('#mapSpotList'); //roomTypeNav
  var mapFixed    = jQuery('#mapFixed');    //roomTypeContent

  if (mapFixed.length === 0) return false;
  
  var mapToggleButton = $('#mapToggleButton');

  var mapFixedPos       = mapFixed.offset();
  var mapSpotListPos    = mapSpotList.offset();
  var mapSpotListPosTop = Math.floor(mapSpotListPos.top);
  var mapSpotListHeight = mapSpotList.height(); //mapFixed
  var topMargin = 72; //120
  var breakPoint;

  if (deviceType() === 'pc') {

    breakPoint = mapSpotListPosTop - topMargin;

  } else {

    breakPoint = 108;

  }
  
  if( winTopPos > breakPoint ){

    mapFixed.addClass('fixed');

    if( winTopPos > ( mapSpotListHeight - 340 ) ) {

      mapFixed
        .removeClass('fixed')
        .addClass('ended')

    } else {

      mapFixed
        .removeClass('ended')
        .addClass('fixed');

    }

  } else {

    mapFixed.removeClass('fixed');

  }

  if (winTopPos > (breakPoint * 2)) {
    mapToggleButton.removeClass('hide');
  } else {
    mapToggleButton.addClass('hide');
  }

}

// スムーススクロール
function smoothScroll(){

  // aタグ要素の参照を取得
  const links = document.querySelectorAll('a[href^="#"]');

  // 各aタグにクリックイベントを設定
  for ( let i = 0; i < links.length; i++ ) {
    links[i].addEventListener('click', function(e){

      // デフォルトのイベントをキャンセル
      e.preventDefault();

      var target        = e.target;
      var targetId      = target.hash;

      if( targetId === '' || targetId === undefined ) return false;

      var targetElement = document.querySelector(targetId);
      var rectTop       = targetElement.getBoundingClientRect().top;

      //ヘッダーの高さを計算
      const headerBar  = document.getElementById('site-header');
      const headerBarHeight = headerBar.offsetHeight;

      var offsetTop = window.pageYOffset;
      var buffer = headerBarHeight;
      var top = rectTop + offsetTop - buffer;

      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
}


// 検索エリア
function searchFormToggle(){

  var searchform = $('#searchform');
  if( searchform.length === 0 ) return false;

  var keywordField = $('input.keyword');

  searchform.on({
    'mouseenter' : function(){

      searchform.parent().addClass('open-searchform');
      var focusTime = setTimeout(function(){

        keywordField.focus();

      }, 600);
    }
  });

  keywordField.on({
    'focusout' : function(){

      searchform.parent().removeClass('open-searchform');

    }

  });

}


// スクロールに反応するサブメニュー
var startPos = 0, winScrollTop = 0;
function fixedHeaderSubContents(){

  winScrollTop = $(this).scrollTop();
  if (winScrollTop >= startPos) {
    if(winScrollTop >= 200){
      $('.header-sub-contents').addClass('hide');
    }
  } else {
    $('.header-sub-contents').removeClass('hide');
  }
  startPos = winScrollTop;

}


// function pageOpening(){

//   var page_body = document.getElementsByTagName('body');
//   setTimeout( function(){
//     page_body[0].classList.remove('loading');
//     page_body[0].classList.add('done');
//   }, 600 );

// }


function delay_href(){

  var link_target = $('a').not('[href^="#"], [href^="javascript"], .noeffect');
  link_target.on({
    'click' : function(e){


      // console.log($(this).data('booking'));
      // return false;

      var winTopPos   = $(window).scrollTop();
      var winHeight   = $(window).height();

      var target_link  = $(this).attr('href');
      var target_blank = $(this).attr('target');
      // var target_data = $(this).data('booking');
      // console.log(target_data);
      // if (target_data === 'bookig') {
      //   location.href = target_link;
      //   return false;
      // }

      e.preventDefault();

      $('body')
        .removeClass('done')
        .addClass('loading');

      setTimeout( function(){

        if (target_blank == '_blank') {

          window.open(target_link);
          
          document.body.classList.remove('loading');
          document.body.classList.remove('open');
          document.body.classList.add('done');

        } else { 

          location.href = target_link;

        }

        return false;

      }, 500 );

    }
  });

}

// MapboxによるNeighborhood Map
function mapBoxInit() {

  if (
    document.getElementById('mapBoxContent') === null ||
    branchLng === null ||
    branchLat === null ||
    branchZoom === null
  ) return false;

    // Mapbox
  mapboxgl.accessToken = 'pk.eyJ1IjoiaG90ZWx0aGVrbm90IiwiYSI6ImNrcDNqZ3EwYzFoODcycHRhYTlyZ3Y5bmUifQ.OfAhgXeQByEMpEG3CzbEGw';
  var map = new mapboxgl.Map({
    container: 'mapBoxContent',
    style: 'mapbox://styles/hoteltheknot/ckp4ofuiq1ru017rpldoz0esc',
    center: [branchLng, branchLat],
    zoom: branchZoom,
    bearing: 20,
    pitch: 30
  });

  map.on('load', function () {

      // add markers to map
    geoJson.features.forEach(function (marker) {

      var classOrder = 'order-' + marker.properties.order;
      var classSlug  = 'marker-' + marker.properties.slug;
      var classId    = marker.id;
      var geometryArray = marker.geometry.center.split(', ');
      var geometryArrayReverse = geometryArray.reverse();

      // create a HTML element for each feature
      var el = document.createElement('div');
      el.className = 'marker' + ' ' + classOrder + ' ' + classSlug + ' ' + classId;
      el.id = 'marker-' + classId;

      new mapboxgl.Marker({
        anchor: 'bottom',
        element: el
      })
        .setLngLat(geometryArrayReverse)
        .addTo(map);
    });

    changeChapter();
    
  });

  var activeChapter = Object.keys(geoJson.chapters[0]);
  var activeChapterName = activeChapter.toString();
  var flyTimer;
  var timeoutId;
    
  // On every scroll event, check which element is on screen
  window.onscroll = function () {

    for (var i = 0; i < geoJson.chapters.length; i++) {
      var chapterName = Object.keys(geoJson.chapters[i]);
      var chapterNameStr = chapterName.toString();

      if (isElementOnScreen(chapterNameStr)) {
        setActiveChapter(chapterNameStr);
        break;
      }

    }
    if (isElementFirstView()) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout( resetMap(), 500 ) ;
    }

  };

  function setActiveChapter(chapterName) {
    if (chapterName === activeChapterName) return;

    var markers = document.getElementsByClassName('marker');
    for (var i = 0; i < markers.length; i++) {
      if (markers[i].id === 'marker-' + chapterName) {
        document.getElementById(markers[i].id).classList.add("active");
      } else {
        document.getElementById(markers[i].id).classList.remove("active");;
      }
    }

    for (var i = 0; i < geoJson.chapters.length; i++) {
      var chapterNameArray = Object.keys(geoJson.chapters[i]);
      var chapterNameStr   = chapterNameArray.toString();

      if (chapterName === chapterNameStr) {
        
        var flyToLatLng = geoJson.chapters[i][chapterName].center.split(', ');
        var flyToLngLat = flyToLatLng.reverse();
        var flyToZoom;

        if (deviceType() === 'pc') {
          flyToZoom = 15;
        } else {
          flyToZoom = 14;
        }

        clearTimeout(flyTimer);
        flyTimer = setTimeout(function () {
          
          map.flyTo({
            center: flyToLngLat,
            zoom: flyToZoom,
            bearing: 0,
            pitch: 0
          });

        }, 300);
      
      }
    }
    
    document.getElementById(chapterName).setAttribute('class', 'active');
    document.getElementById(activeChapterName).setAttribute('class', '');
    
    activeChapterName = chapterName;
  }
    
  function isElementOnScreen(id) {
    var element = document.getElementById(id);
    var bounds = element.getBoundingClientRect();
    return ( bounds.top + 200 ) < window.innerHeight && bounds.bottom > 300;
  }

  function isElementFirstView() {
    var windowHeight = window.innerHeight;
    var scrollY      = window.pageYOffset;

    return ( windowHeight / 3 ) > scrollY;

  }

  function resetMap() {
    // console.log('reset');
    var target = document.getElementById('mapBoxContent');
    var button = document.getElementById('mapToggleButton');
    var labels = document.getElementById('controlLabels');
    target.classList.remove('hidden');
    button.classList.remove('open');
    button.classList.add('close');
    button.classList.add('hide');
    labels.classList.remove('hidden');

  }

  function changeChapter() {

    var markers = document.getElementsByClassName('marker');

    for ( var i = 0; i < markers.length; i++ ) {

      markers[i].addEventListener('click', function (e) {
        var spotId = this.id.replace('marker-','');
        var targetSpot = document.getElementById(spotId);

        var rect = targetSpot.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var myTop = rect.top + scrollTop;
        var scrollToTop;

        if (deviceType() === 'pc') {
          scrollToTop = myTop - 200;
        } else {
          scrollToTop = myTop - 272;
        }
        

        window.scrollTo({
          top: scrollToTop,
          left: 0,
          behavior: 'smooth'
        });
        return false;
      });
        
    }

  }
  
}

// 
function changeMapSelectLocation() {

  var target = document.getElementById('mapSelectLocaion');

  if ( target === null ) return false;

  var closeButton = document.getElementById('locationSelect');
  var currentLabel = target.getElementsByTagName('p')[0];
  
  target.addEventListener('mouseenter', function (e) {
    this.classList.add('show');
    return false;
  });

  target.addEventListener('mouseleave', function (e) {
    this.classList.remove('show');
    return false;
  });

  closeButton.addEventListener('touchend', function (e) {
    target.classList.remove('show');
  });
  currentLabel.addEventListener('touchend', toggleClass);

  function toggleClass(e) {

    if (target.classList.contains('show')) {

      target.classList.remove('show');
      
    } else {
      
      target.classList.add('show');

    }

    return false;

  }

}

window.addEventListener('resize', changeMapSelectLocation);

// 
function toggleMapArea() {

  if ( document.getElementById('mapToggleButton') === null ) return false;

  var button = document.getElementById('mapToggleButton');
  var target = document.getElementById('mapBoxContent');
  var labels = document.getElementById('controlLabels');

  button.addEventListener('click', function (e) {
    if (!target.classList.contains('hidden')) {
      this.classList.add('open');
      this.classList.remove('close');
      target.classList.add('hidden');
      labels.classList.add('hidden');
    } else {
      this.classList.remove('open');
      this.classList.add('close');
      target.classList.remove('hidden');
      labels.classList.remove('hidden');
    }
  });

}

function closeNotification() {
  var ieNotification = document.getElementById('ie-notification');
  if (ieNotification === null ) return false;

  ieNotification.addEventListener('click', function () {
    this.classList.add('hide');
  });
}

function checkContactForm(){

  var targetFrom = document.querySelector('form.wpcf7-form');
  if( targetFrom === null ) return false;

  var targetFields = targetFrom.querySelectorAll('.wpcf7-form-control');

  targetFields.forEach(function (el) {
    el.addEventListener('focus', function () {
      el.parentNode.parentNode.classList.add('active');
    });
    el.addEventListener('blur', function () {
      if (el.value.length === 0) {
        el.parentNode.parentNode.classList.remove('active');
      }
    });
  });

}

document.addEventListener('DOMContentLoaded', checkContactForm);



jQuery( function($){

  changeMapSelectLocation();
  // mapBoxInit();
  toggleMapArea();
  closeNotification();

  var dropdown_list = $('.dropdown-list');
  dropdown_list.each(function(){

    dropdownControl( $(this) );

  });

  var booking_list = $('.booking-list');
  bookingControl( booking_list );

  var sns_list_control   = listControl('.global-sns-list');
  var hotel_list_control = listControl('.hotel-list');
  drawerControl();
  //localNavigationControl();
  smoothScroll();
  changeLocation();
  changeGenre();
  searchFormToggle();

  // pageOpening();
  delay_href();

});

var scrollTimer;
$(window).on({
  'scroll' : function(){

    var winTopPos = $(window).scrollTop();
    clearTimeout(scrollTimer);

    // scrollTimer = setTimeout(function () {
    // fixedRoomSideMenu(winTopPos);
    fixedMap(winTopPos, scrollTimer);
    fixedHeaderSubContents();
    // }, 300 );

  }

});



// Booking Button
function bookingButtonControl() {
  
  // const bookingButton = document.getElementById('bookingButton');
  const bookingButton = document.querySelectorAll('.booking-button');

  if( bookingButton === null ) return false;

  bookingButton.forEach(function (element, index) {

    element.addEventListener('click', function (e) {
      element.parentElement.classList.toggle('show');
      document.body.dataset.modalOpen = element.parentElement.classList.contains('show') ? 'show' : 'hide';
      return false;
    });

  });

}

function init() { 
  bookingButtonControl();

  const visualLength = document.querySelectorAll('.swiper-visual .swiper-slide').length;

  const locations = [];
  document.querySelectorAll('.swiper-visual .swiper-slide').forEach(function (element, index) {
    locations.push(element.dataset.location);
  });

  console.debug(locations);

  if (visualLength > 1) {
    const swiperVisual = new Swiper('.swiper-visual', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1500,
      // grabCursor: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + locations[index] + "</span>";
        }
      },
      autoplay: {
        delay: 6000
      }
    });
  }

  const swiperHotels = new Swiper ('.swiper-hotels', {
    // loop: true,
    slidesPerView: 1.3,
    spaceBetween: 28,
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-hotels-button-next",
      prevEl: ".swiper-hotels-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      768: {
        slidesPerView: 4,
        spaceBetween: 40,
        centeredSlides: false,
      }
    }
  });

  const swiperGlobalCafe = new Swiper ('.swiper-global-cafe', {
    // init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1200,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    }
  });

  // const postLength = document.querySelectorAll('.swiper-posts .swiper-slide').length;
  // if (postLength > 3) { 

    const swiperPosts = new Swiper ('.swiper-posts', {
      // loop: true,
      slidesPerView: 1.3,
      spaceBetween: 28,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 3.5,
          spaceBetween: 40,
          centeredSlides: false,
        }
      }
    });

  // }


  const observerOptions = {
    root: null,
    rootMargin: '-10%',
    threshold: 0
  }
  const fadeInUpAll = document.querySelectorAll('[data-inview]');
  intersectAction(fadeInUpAll, function (element, isIntersecting) {
    if (isIntersecting) {
      element.classList.add('isShow');
    } else { 
      // element.classList.remove('isShow');
    }
  }, observerOptions);

}

document.addEventListener('DOMContentLoaded', init);


window.addEventListener('scroll', function (e) { 

  // clearTimeout(timerId);
  // timerId = setTimeout(() => { 
    winScrollTop = window.pageYOffset;
    winHeight = window.innerHeight;

    if ( winScrollTop > 1 ) {

      document.body.dataset.scroll = "scrolled";

    } else { 

      document.body.dataset.scroll = "unscroll";

    }

    if ( startPos < winHeight * 1 || winScrollTop <= 0) {

      document.body.dataset.view = "first";

    } else { 

      document.body.dataset.view = "second";

    }
    startPos = winScrollTop;
  // }, 100);
  return false;
});

